import styled, { css } from 'styled-components'

import { CertificationStatus } from '@cdab/scania/qpr/schema'

type Props = {
  certification: CertificationStatus
}

export const Title = styled.h4`
  text-transform: capitalize;
`

export const StyledCertification = styled.span.attrs<Props>({
  className: 'tds-detail-04'
})<Props>`
  ${({ certification }) => css`
    color: ${certification === CertificationStatus.Certified
      ? 'var(--tds-green-500)'
      : certification === CertificationStatus.Expired
      ? 'var(--tds-red-500)'
      : 'var(--tds-grey-500)'};
  `};
`
